import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // StrictMode disabled to prevent double API calls in development
  // Re-enable for production builds if needed
  <App />
);

// Enable hot module replacement (HMR)
if (import.meta.hot) {
  import.meta.hot.accept();
}
